"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Fact_1 = __importDefault(require("../Fact/Fact"));

var FactList_meta_1 = require("./FactList.meta");

var List_1 = __importDefault(require("../../base/List/List"));

var AccordionPanel_1 = __importDefault(require("../../base/AccordionPanel/AccordionPanel"));

var mobx_1 = require("mobx");

var factHasValue_1 = require("../../../shared/factHasValue");

var FactList =
/** @class */
function (_super) {
  __extends(FactList, _super);

  function FactList(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = FactList_meta_1.FACT_LIST_CATEGORY_KEY;
    _this.componentKey = FactList_meta_1.FACT_LIST_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(FactList.prototype, "itemBlankDataOptions", {
    get: function get() {
      var _a = this.props.itemBlankDataOptions,
          itemBlankDataOptions = _a === void 0 ? {} : _a;
      var defaults = {
        showBlank: true,
        placeholder: 'N/A'
      };
      return Object.assign(defaults, itemBlankDataOptions);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FactList.prototype, "listBlankDataOptions", {
    get: function get() {
      var _a = this.props.listBlankDataOptions,
          listBlankDataOptions = _a === void 0 ? {} : _a;
      var defaults = {
        showBlank: true,
        placeholder: 'No list data available'
      };
      return Object.assign(defaults, listBlankDataOptions);
    },
    enumerable: true,
    configurable: true
  });

  FactList.prototype.showItem = function (item) {
    var showBlank = this.itemBlankDataOptions.showBlank;
    var blankDataOptions = item.blankDataOptions;
    var itemShowBlank = blankDataOptions && !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(blankDataOptions.showBlank) ? blankDataOptions.showBlank : showBlank;

    if (item.hide) {
      return false;
    }

    return itemShowBlank || factHasValue_1.factHasValue(item);
  };

  Object.defineProperty(FactList.prototype, "items", {
    get: function get() {
      var _this = this;

      var _a = this.props,
          _b = _a.items,
          items = _b === void 0 ? [] : _b,
          listValueSeparator = _a.listValueSeparator,
          onDocumentClick = _a.onDocumentClick;
      var mappedItems = items.filter(function (item) {
        return _this.showItem(item);
      }).map(function (factProps) {
        var blankDataOptions = __assign(__assign({}, _this.itemBlankDataOptions), factProps.blankDataOptions);

        if (!factProps.onDocumentClick && onDocumentClick) {
          factProps.onDocumentClick = onDocumentClick;
        }

        return react_1.default.createElement(Fact_1.default, __assign({}, factProps, {
          listValueSeparator: factProps.listValueSeparator || listValueSeparator,
          blankDataOptions: blankDataOptions
        }));
      });
      return mappedItems;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FactList.prototype, "factList", {
    get: function get() {
      var _a = this.props,
          heading = _a.heading,
          headingTooltip = _a.headingTooltip;
      var items = this.items;
      return react_1.default.createElement(List_1.default, {
        items: items,
        heading: heading,
        headingTooltip: headingTooltip,
        blankDataOptions: this.listBlankDataOptions
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FactList.prototype, "factAccordion", {
    get: function get() {
      var _a = this.props,
          _b = _a.heading,
          heading = _b === void 0 ? '' : _b,
          headingTooltip = _a.headingTooltip;
      var items = this.items;
      return react_1.default.createElement(AccordionPanel_1.default, {
        heading: heading,
        headingTooltip: headingTooltip,
        panelKey: heading,
        isOpen: true
      }, react_1.default.createElement(List_1.default, {
        items: items,
        blankDataOptions: this.listBlankDataOptions
      }));
    },
    enumerable: true,
    configurable: true
  });

  FactList.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.mode,
        mode = _b === void 0 ? 'list' : _b;
    var showBlank = this.listBlankDataOptions.showBlank;
    var items = this.items;

    if (items.length === 0 && !showBlank) {
      return null;
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, mode === 'list' ? this.factList : this.factAccordion);
  };

  __decorate([mobx_1.computed], FactList.prototype, "itemBlankDataOptions", null);

  __decorate([mobx_1.computed], FactList.prototype, "listBlankDataOptions", null);

  __decorate([mobx_1.computed], FactList.prototype, "items", null);

  __decorate([mobx_1.computed], FactList.prototype, "factList", null);

  __decorate([mobx_1.computed], FactList.prototype, "factAccordion", null);

  FactList = __decorate([mobx_react_1.observer], FactList);
  return FactList;
}(shared_1.ComponentBase);

exports.FactList = FactList;
exports.default = shared_1.InjectedStyledComponent(FactList, FactList_meta_1.FACT_LIST_CATEGORY_KEY, FactList_meta_1.FACT_LIST_COMPONENT_KEY);